var config = {
    apiKey: "AIzaSyA1Uz8ky97wM4Qs3yohSULMEhKx96hFPSA",
    authDomain: "photo-site-474ab.firebaseapp.com",
    databaseURL: "https://photo-site-474ab.firebaseio.com",
    projectId: "photo-site-474ab",
    storageBucket: "photo-site-474ab.appspot.com",
    messagingSenderId: "976713482144"
};
module.exports = config;


// WEBPACK FOOTER //
// ./src/Firebase/config.js